import type { FloatingPosition } from '@mantine/core/lib/Floating';
import type { ISecodaEntity } from '../../api';
import type { PropertySelectorProps } from './PropertySelector';
import { PropertySelector } from './PropertySelector';

export interface StatusPropertySelectorProps
	extends Pick<PropertySelectorProps, 'onChange'> {
	entity: ISecodaEntity;
	viewerOfEntity: boolean;
	position?: FloatingPosition;
	withinPortal?: boolean;
}

export function StatusPropertySelector({
	entity,
	viewerOfEntity,
	position,
	withinPortal,
	...propertySelectorProps
}: StatusPropertySelectorProps) {
	return (
		<PropertySelector
			selected={entity.published}
			type="single"
			value="published"
			iconType="tabler"
			isViewerUser={viewerOfEntity}
			readOnly={viewerOfEntity}
			position={position}
			withinPortal={withinPortal}
			{...propertySelectorProps}
		/>
	);
}
